import { render, staticRenderFns } from "./editProviderRtp.vue?vue&type=template&id=386a8168&lang=pug"
import script from "./editProviderRtp.vue?vue&type=script&lang=js"
export * from "./editProviderRtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports